import { get } from '../../utils'

export const getters = {
  isDarkMode: get('darkMode'),
  getDrawer: get('navigationDrawer')
}

export default getters
